import cn from "classnames";
import type { ComponentProps } from "react";
import styles from "./Badge.module.css";

interface BadgeProps extends ComponentProps<"span"> {
  variant: "primary" | "error";
}

export function Badge(props: BadgeProps) {
  const { className, variant, ...rest } = props;

  return (
    <span className={cn(styles.badge, styles[variant], className)} {...rest} />
  );
}
